import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconFacebook = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <path d="M17 8.55285C17 3.83161 13.1921 0 8.5 0C3.80793 0 0 3.83161 0 8.55285C0 12.8249 3.10762 16.3658 7.17816 17V11.0192H5.00721V8.55285H7.17816V6.66788C7.17816 4.52746 8.43872 3.33834 10.3821 3.33834C11.31 3.33834 12.2729 3.51451 12.2729 3.51451V5.60207H11.2049C10.1457 5.60207 9.81308 6.2715 9.81308 6.94093V8.54404H12.1766L11.8002 11.0104H9.81308V16.9912C13.8924 16.3658 17 12.8249 17 8.55285Z" fill="currentColor" />
    </svg>
  )
}

export default IconFacebook
